<template>
<div>

  <spinner v-bind:spinner='spinner'></spinner>
 
  <h4 style="color:blue">RICERCA PRODOTTI DEL FORNITORE<p > <strong>  {{supplier}} </strong></p></h4>
   
   
  <button @click="close()" class="btn btn-primary mb-1">
    <i style="color:yellow" class="fas fa-window-close mr-2" aria-hidden="true"></i>
    CHIUDI</button>

  <form name="findProduct" v-on:submit.prevent="findProducts()">
  <div class="form-group">
    <label class="" for="codiceArticolo"><strong>Codice prodotto fornitore</strong></label>      
    <input v-focus autocomplete="off" type="text"   class="form-control " id="codiceArticolo" placeholder="Digitare un codice prodotto fornitore e premere invio." v-model="sku">
   
  </div>
  </form>
  
  <alert-box @close="msg.title=''" v-bind:msg="msg"  ></alert-box>

  <div class="table-wrapper-scroll-y my-custom-scrollbar mt-2">

  <table class="table table-hover table-sm table-striped mb-0">
    <thead class="table-primary" >
      <tr>
        <th scope="col">ID</th>
        <th scope="col">CODICE</th>
        <th scope="col">BRAND</th>
        <th scope="col">CATEGORIA</th>
        <th scope="col">DESCRIZIONE</th>
        <th scope="col">REPARTO</th>
        <th scope="col">STAGIONE</th>
        <th scope="col">DATA REG.</th>
        <th scope="col">N.RO VARIANTI</th>
       
      </tr>
    </thead>
    <tbody>
      <tr data-toggle="tooltip" title="Doppio click seleziona Prodotto" class="pointer" v-on:dblclick="setProduct(item)" v-for="(item, index) in items" :key="index">
        <td>{{item.productId}}</td>
        <td>{{item.sku}}</td>
        <td>{{item.brand}}</td>
        <td>{{item.category}}</td>
        <td>{{item.description}}</td>
        <td>{{item.department}}</td>
        <td>{{item.season}}-{{item.season_year}} </td>
        <td>{{item.create_at}} </td>
        <td>{{item.counter}} </td>
       
      </tr> 
    </tbody>
  </table>

</div>
</div>


</template>
<script>
import alertBox          from '@/components/common/AlertBox.vue';
import spinner           from '@/components/common/Spinner.vue';



import api               from '@/api'
import { mapGetters }    from 'vuex';

export default {
  
  components  : {alertBox,spinner},
  props : ['supplierId'],
  data() {
    return {
      supplier        : '',  
      sku             : '',
      items           : [],
      
      msg             : {
        title : '',
        body  : '',
        type  : 0      
      },
      
      

      spinner         : false    
      
    };
  },
  computed :{

    ...mapGetters(['company']),
    
  },
  directives: {
    focus: {
      // directive definition
      inserted: function(el) {
        el.focus();
      }
    }
  },
  mounted: function() {},
  created: function() {
    this.getSupplier()
  },  
  methods: {
    close()
    {
      const item = {}
      item.productId = 0
      this.$emit('update',item)
    },

    async setProduct(product)
    {
     
      this.msg.title = ''  
      this.spinner = true          
      var sp = {'sp':'spProductBarcodes'}
      
      var data  = {'productId' : product.productId}
      var json  = Object.assign(data, sp);
      await api.post(json).then(res => {
        if(res.status==200)
          {
            product.barcodes = res.data.recordsets[0]
            this.$emit('update',product)         
          }
          else if(res.status==500)
          {
          
            this.msg.title = 'ATTENZIONE '
            this.msg.body = res.data
            this.msg.type = 1

          } 
          else
          {
          
            this.msg.title = 'ATTENZIONE '
            this.msg.body = res
            this.msg.type = 1
          } 
      }).catch(err => 
      {
        
          this.msg.title = 'ATTENZIONE '
          this.msg.body = err.message
          this.msg.type = 1    
          
      }).finally(() => {
        this.spinner = false
      });

      

    },

    
    async getSupplier()
    {
      this.spinner = true
      
      var sp       = {'sp' : 'spSupplierBySupplierId'}
      var data     = {'supplierId' : this.supplierId}
      var json     = Object.assign(data, sp);
      await api.post(json).then(res => {
        if(res.status==200)
          {
            this.supplier = res.data.recordsets[0][0].supplier         
          }
          else if(res.status==500)
          {
              this.msg.title = 'ATTENZIONE '
              this.msg.body  = res.data
              this.msg.type  = 1
            

          } 
          else
          {

            this.msg.title = 'ATTENZIONE '
            this.msg.body  = res
            this.msg.type  = 1
            

          } 
      }).catch(err => 
      {
        
          this.msg.title = 'ATTENZIONE '
          this.msg.body  = err.message
          this.msg.type  = 1

      }).finally(() => {
        this.spinner = false
      });


     



      
    },
    async findProducts() {
      
      

      this.msg.title = ''
      this.spinner = true
          
      var sp       = {'sp' : 'spProductsSupplier'}
      var data     = {'supplierId' : this.supplierId,'sku':this.sku,'companyId':this.company.Id}
      var json     = Object.assign(data, sp);
      
      await api.post(json).then(res => {
        if(res.status==200)
          {
            this.items = res.data.recordsets[0]
            if(this.items.length==0)
            {
              
              this.msg.title = 'ATTENZIONE '
              this.msg.body  = 'Codice prodotto inesistente.'
              this.msg.type  = 1
            }
         
          }
          else if(res.status==500)
          {
           
              this.msg.title = 'ATTENZIONE '
              this.msg.body  = res.data
              this.msg.type  = 1
          } 
          else
          {
            this.msg.title = 'ATTENZIONE '
            this.msg.body  = res
            this.msg.type  = 1
            
          } 
      }).catch(err => 
      {
        this.msg.title = 'ATTENZIONE '
        this.msg.body  = err.message
        this.msg.type  = 1
        
        
      }).finally(() => {
        this.spinner = false
      });  

      

    }
  }
};
</script>
<style scoped>

.my-custom-scrollbar {
position   : relative;
height     : 500px;
overflow   : auto;
}
.pointer:hover
{
  background-color  : blue;
  color             : white;
  cursor            : pointer;
}
.table-wrapper-scroll-y {
display: block;
}
.table thead  tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
    font-size    : 16px;
    background   : hwb(45 4% 9%);  
    color        : black;   
    position     : sticky;
    top          : 0;
    z-index      : 10;
    height       : 40px;

 }


h4 {
  font-family: 'Roboto Condensed';
  font-size: 18px;
}
p {
  font-family  : 'Roboto Condensed';
  font-size    : 28px;
  color        :darkgreen;
}
</style>